const space = [
    0,
    '8px',
    '16px',
    '24px',
    '32px',
    '40px',
    '48px',
    '56px',
    '64px',
    '112px',
] as const;

const halfSizesMap = {
    half0: '4px', // xs
    half1: '12px',
    half2: '20px', // lg
    half3: '36px',
    half4: '44px', // xxxl
};

const spaceMap = {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '20px',
    xl: '24px',
    xxl: '32px',
    xxxl: '44px',
} as const;

export default {
    space,
    halfSizesMap,
    spaceMap,
};
